import { render, staticRenderFns } from "./CustomerFindMatch.vue?vue&type=template&id=8da3278c"
import script from "./CustomerFindMatch.vue?vue&type=script&lang=ts"
export * from "./CustomerFindMatch.vue?vue&type=script&lang=ts"
import style0 from "./CustomerFindMatch.vue?vue&type=style&index=0&id=8da3278c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports